<template>
  <div class="grid-div">
    <v-card v-for="i in 5" class="title-card" :key="i" v-t="{path: 'info.scopes.SCOPE' + i + '.TITLE', locale: questionnaire.version}"/>

    <template v-for="{item, complexity} in items">
      <evaloe-results-item v-if="item !== undefined" :key="item" :complexity="complexity" :item="item" :version="questionnaire.version" :answered="isAnswered(item)" :answer="getResponse(item)" :chosen="isChosen(item)"></evaloe-results-item>
      <div v-else :key="item"></div>
    </template>

  </div>
</template>

<style scoped>
.grid-div {
  padding: 0 15%;
  display: grid;
  grid-auto-rows: 1fr;
  grid-template-columns: auto auto auto auto auto;
  grid-gap: 4px;
}

.title-card {
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  padding: 5px;
}
</style>

<script>
  import EvaloeResultsItem from './EvaloeResultsItem'
  export default {
    name: 'evaloeResults',
    props: ['questionnaireItems', 'questionnaire', 'recommendations'],
    components: {
      'evaloe-results-item': EvaloeResultsItem
    },
    data () {
      return {
        questionnaireItems: this.questionnaireItems,
        questionnaire: this.questionnaire,
        items: [
          {item: 1, complexity: '3'},
          {item: 7, complexity: '3'},
          {item: 13, complexity: '3'},
          {item: 16, complexity: '3'},
          {item: 24, complexity: '3'},
          {item: 2, complexity: '3'},
          {item: 8, complexity: '2'},
          {item: 14, complexity: '2'},
          {item: 17, complexity: '1'},
          {item: 25, complexity: '2'},
          {item: 3, complexity: '2'},
          {item: 9, complexity: '2'},
          {item: 15, complexity: '1'},
          {item: 18, complexity: '1'},
          {item: 26, complexity: '2'},
          {item: 4, complexity: '2'},
          {item: 10, complexity: '2'},
          {item: undefined, complexity: undefined},
          {item: 19, complexity: '1'},
          {item: 27, complexity: '1'},
          {item: 5, complexity: '2'},
          {item: 11, complexity: '2'},
          {item: undefined, complexity: undefined},
          {item: 20, complexity: '1'},
          {item: 28, complexity: '1'},
          {item: 6, complexity: '1'},
          {item: 12, complexity: '2'},
          {item: undefined, complexity: undefined},
          {item: 21, complexity: '1'},
          {item: 29, complexity: '1'},
          {item: undefined, complexity: undefined},
          {item: undefined, complexity: undefined},
          {item: undefined, complexity: undefined},
          {item: 22, complexity: '1'},
          {item: 30, complexity: '1'},
          {item: undefined, complexity: undefined},
          {item: undefined, complexity: undefined},
          {item: undefined, complexity: undefined},
          {item: 23, complexity: '1'},
          {item: undefined, complexity: undefined}
        ]
      }
    },
    created: function () {
    },
    mounted: function () {
      if (this.questionnaire === null) {
        this.questionnaire = {}
        this.questionnaire.version = this.$auth.user().version
      }
    },
    watch: {

    },
    computed: {

    },
    methods: {
      findQuestionnaireItem: function (itemId) {
        var a = this._.find(this.questionnaireItems, function (i) {
          return i.itemId === itemId
        })
        if (a == null) return false
        else return a
      },
      isAnswered: function (itemId) {
        if (this.questionnaireItems.length > 0) {
          for (var i in this.questionnaireItems) {
            if (this.questionnaireItems[i].itemId === itemId && this.questionnaireItems[i].answered === true) {
              return true
            }
          }
        }
        return false
      },
      getResponse: function (itemId) {
        var answer = this.findQuestionnaireItem(itemId).answer
        var color = 'gray'
        switch (answer) {
          case 1:
            color = 'red'
            break
          case 2:
            color = 'orange'
            break
          case 3:
            color = 'green'
            break
          default:
            color = 'gray'
        }
        return color
      },
      isChosen: function (itemId) {
        var a = this._.find(this.recommendations, function (i) {
          return i.chosen && i.itemId === itemId
        })
        if (a == null) return false
        else return a
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/questionnaires/EvaloeResults.vue